module.exports = __webpack_public_path__ + "img/149ne.ff0ed9a2.svg";